export const readConfig = (variable) => {
  try {
    if (typeof window === 'undefined') {
      return '';
    }
    return window.__EXPERIENCE_PROPS__.expConfiguration[variable];
  } catch {
    return '';
  }
};